var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBagxd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_974_13880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4005 27.6C90.2005 23.3 86.7005 20 82.4005 20H70.0005C70.0005 9 61.0005 0 50.0005 0C39.0005 0 30.0005 9 30.0005 20H17.6005C13.3005 20 9.80052 23.3 9.60052 27.6L6.40052 91.6C6.20052 96.2 9.80052 100 14.4005 100H85.6005C90.2005 100 93.8005 96.2 93.6005 91.6L90.4005 27.6ZM34.0005 20C34.0005 11.2 41.2005 4 50.0005 4C58.8005 4 66.0005 11.2 66.0005 20H34.0005ZM88.5005 94.8C87.7005 95.6 86.7005 96 85.6005 96H14.4005C13.3005 96 12.3005 95.6 11.5005 94.8C10.7005 94 10.3005 92.9 10.4005 91.8L13.6005 27.8C13.7005 25.7 15.5005 24 17.6005 24H30.0005V44C30.0005 45.1 30.9005 46 32.0005 46C33.1005 46 34.0005 45.1 34.0005 44V24H66.0005V44C66.0005 45.1 66.9005 46 68.0005 46C69.1005 46 70.0005 45.1 70.0005 44V24H82.4005C84.5005 24 86.3005 25.7 86.4005 27.8L89.6005 91.8C89.6005 92.9 89.3005 94 88.5005 94.8Z",
    fill: "#A78721"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_974_13880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagxd);
export default __webpack_public_path__ + "static/media/shopping_bagxd.e23cf0ae06a4fe08e8ffd3bd77c5c6cb.svg";
export { ForwardRef as ReactComponent };